<template>
  <div class="passenger-summary">
    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">Title</b>
      <div class="passenger-summary__value">{{details.title}}</div>
    </div>

    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">First Name</b>
      <div class="passenger-summary__value">{{details.firstName}}</div>
    </div>

    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">Other Names</b>
      <div class="passenger-summary__value">{{details.otherNames}}</div>
    </div>

    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">Surname</b>
      <div class="passenger-summary__value">{{details.lastName}}</div>
    </div>

    <template v-if="details.lead">
      <div class="passenger-summary__field">
        <b class="passenger-summary__attribute">Mobile Phone Number</b>
        <div class="passenger-summary__value">{{details.mobilePhone}}</div>
      </div>

      <div class="passenger-summary__field">
        <b class="passenger-summary__attribute">Home Phone Number</b>
        <div class="passenger-summary__value">{{details.homePhone}}</div>
      </div>

      <div class="passenger-summary__field">
        <b class="passenger-summary__attribute">Email Address</b>
        <div class="passenger-summary__value">{{details.email}}</div>
      </div>
    </template>

    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">Date of Birth</b>
      <div
        class="passenger-summary__value"
      >{{details.dayOfBirth}} {{getMonthName(details.monthOfBirth)}} {{details.yearOfBirth}}</div>
    </div>

    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">Sex (indicated by passport)</b>
      <div class="passenger-summary__value">{{details.sex}}</div>
    </div>

    <div v-if="details.lead" class="passenger-summary__field">
      <b class="passenger-summary__attribute">Address</b>
      <div class="passenger-summary__value">
        <span v-for="line in details.address.addressLines" :key="line">
          {{line}}
          <br />
        </span>
        {{details.address.town}}
        <br />
        {{details.address.county}}
        <br />
        {{details.address.country}}
        <br />
        {{details.address.postCode}}
      </div>
    </div>

    <template v-for="(visaRequired, visaId) in details.visaIds">
      <div class="passenger-summary__field" :key="visaId">
        <b class="passenger-summary__attribute">{{getVisaNameFromCode(visaId)}}</b>
        <div class="passenger-summary__value">{{visaRequired}}</div>
      </div>
    </template>

    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">Medical/Mobility Limitations</b>
      <div
        class="passenger-summary__value"
      >{{details.mobilityLimitations ? details.mobilityDetails : 'None'}}</div>
    </div>

    <div class="passenger-summary__field">
      <b class="passenger-summary__attribute">Dietary Requirements</b>
      <div
        class="passenger-summary__value"
      >{{details.dietaryRequests ? details.dietaryRequirements : 'None'}}</div>
    </div>

    <div v-if="details.lead" class="passenger-summary__field">
      <b class="passenger-summary__attribute">Marketing Communication</b>
      <div class="passenger-summary__value">
        Receive via mail -
        <b>{{details.marketingMail ? 'Yes' : 'No'}}</b>
        <br />Receive via email -
        <b>{{details.marketingEmail ? 'Yes' : 'No'}}</b>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { monthName } from '@/utils';

export default {
  props: ['details'],

  computed: {
    ...mapGetters('checkout', ['getVisaNameFromCode'])
  },

  methods: {
    getMonthName(month) {
      return monthName(month);
    }
  }
};
</script>
